import type { QueryPlanSpec } from '../model.js';

export function queryPlanFixture(
  width = 640,
  stress = false,
  focusNodeId?: string,
): QueryPlanSpec {
  return stress
    ? {
        id: 'query-plan-stress',
        family: 'query-plan',
        view: 'schematic',
        viewport: { width, height: 550 },
        rootId: 'group-customer-region',
        nodes: [
          {
            id: 'group-customer-region',
            label: 'HashAggregate grouped by customer geographic region',
            kind: 'aggregate',
            estimatedRows: 18,
            cost: 18_942.77,
          },
          {
            id: 'sort-net-revenue',
            label: 'Sort by descending net revenue with deterministic tie break',
            kind: 'sort',
            estimatedRows: 18,
            cost: 18_941.92,
          },
          {
            id: 'join-orders-customers',
            label: 'Hash Join orders.customer_id = customers.id',
            kind: 'join',
            estimatedRows: 12_480,
            cost: 18_735.41,
          },
          {
            id: 'scan-qualified-orders',
            label: 'Parallel sequential scan of fulfilled orders in reporting window',
            kind: 'scan',
            estimatedRows: 1_284_000,
            cost: 15_401.22,
            relation: 'orders',
          },
          {
            id: 'scan-active-customers',
            label: 'Index-only scan of active enterprise customer accounts',
            kind: 'scan',
            estimatedRows: 84_200,
            cost: 2_909.86,
            relation: 'customers',
          },
        ],
        edges: [
          { from: 'sort-net-revenue', to: 'group-customer-region', label: '18 grouped rows' },
          { from: 'join-orders-customers', to: 'sort-net-revenue', label: '12.5k joined rows' },
          { from: 'scan-qualified-orders', to: 'join-orders-customers', label: '1.28m candidate order rows' },
          { from: 'scan-active-customers', to: 'join-orders-customers', label: '84.2k active customer rows' },
        ],
        ...(focusNodeId ? { focusNodeId } : {}),
        provenance: 'PostgreSQL-style analytical query plan · estimated rows and planner cost are explicit teaching inputs',
      }
    : {
        id: 'query-plan',
        family: 'query-plan',
        view: 'schematic',
        viewport: { width, height: 470 },
        rootId: 'sum-revenue',
        nodes: [
          { id: 'sum-revenue', label: 'Aggregate revenue', kind: 'aggregate', estimatedRows: 1, cost: 921.4 },
          { id: 'join-customer', label: 'Hash Join customer', kind: 'join', estimatedRows: 2_480, cost: 908.2 },
          { id: 'scan-orders', label: 'Scan recent orders', kind: 'scan', estimatedRows: 18_200, cost: 702.1, relation: 'orders' },
          { id: 'scan-customers', label: 'Scan active customers', kind: 'scan', estimatedRows: 4_100, cost: 181.6, relation: 'customers' },
        ],
        edges: [
          { from: 'join-customer', to: 'sum-revenue' },
          { from: 'scan-orders', to: 'join-customer' },
          { from: 'scan-customers', to: 'join-customer' },
        ],
        ...(focusNodeId ? { focusNodeId } : {}),
        provenance: 'PostgreSQL-style revenue query plan · estimated rows and planner cost are explicit teaching inputs',
      };
}

export const defaultQueryPlanFocus = 'join-orders-customers';
